export default function Footer({ C, onNavigate }) {
  const year = new Date().getFullYear();
  return (
    <footer style={{ borderTop: `1px solid ${C.border}`, padding: "32px 20px", marginTop: 40 }}>
      <div style={{
        maxWidth: 1080, margin: "0 auto", display: "flex", flexWrap: "wrap",
        alignItems: "center", justifyContent: "space-between", gap: 16,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{
            width: 28, height: 28, borderRadius: 8,
            background: `linear-gradient(135deg, ${C.primary}, ${C.primaryDark})`,
            display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden",
          }}>
            <img src="/logo.webp" alt="" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          </div>
          <span style={{ color: C.text, fontWeight: 800, fontSize: 14 }}>CuadraAI</span>
        </div>

        <nav aria-label="Enlaces del pie de página" style={{ display: "flex", flexWrap: "wrap", gap: 18, alignItems: "center" }}>
          <a href="#inicio" style={linkStyle(C)}>Inicio</a>
          <a href="#caracteristicas" style={linkStyle(C)}>Características</a>
          <button onClick={() => onNavigate?.("privacy")} style={{ ...linkStyle(C), background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", padding: 0 }}>
            Privacidad
          </button>
          <button onClick={() => onNavigate?.("terms")} style={{ ...linkStyle(C), background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", padding: 0 }}>
            Términos
          </button>
          <a href="mailto: prodjeighost@gmail.com" style={linkStyle(C)}>Contacto</a>
        </nav>

        <span style={{ color: C.muted, fontSize: 11.5 }}>v1.0.0 · © {year} CuadraAI</span>
      </div>
    </footer>
  );
}

function linkStyle(C) {
  return {
    color: C.muted,
    fontSize: 13,
    fontWeight: 600,
    textDecoration: "none",
  };
}